/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * HyusnSu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Thu Mar 23 2023
 **/

import { useTheme } from "@emotion/react";

import useTab from "./useTab";
import { tabItemStyle } from "./private/emotion";

export default function TabItem({ id, children, ...rest }: React.HTMLAttributes<HTMLLIElement>) {
	const { uiType, currentId, allActive, handleSelectTab } = useTab();
	const theme = useTheme();
	const handleClick = (e: React.MouseEvent<HTMLLIElement>) => {
		e.stopPropagation();

		const target = e.currentTarget as HTMLLIElement;
		if (!target || !target.id) return;
		handleSelectTab(target.id);
	};

	return (
		<>
			<li
				{...rest}
				id={id}
				css={tabItemStyle(allActive ? allActive : currentId === id, uiType, theme)}
				onClick={rest.onClick || handleClick}
			>
				{children}
			</li>
		</>
	);
}
